<template>
  <aside class="bazaargah-touchpoint">
    <div class="bazaargah-touchpoint__card">
      <img
        class="bazaargah-touchpoint__image"
        :src="require('@/assets/images/bazaargah/touchPoint.svg')"
        width="120"
        height="83"
        alt=""
      />

      <p class="bazaargah-touchpoint__description">
        {{ $t('BAZAARGAH_TOUCHPOINT.DESCRIPTION') }}
      </p>

      <a
        class="bazaargah-touchpoint__link"
        :href="$router.resolve({ name: 'bazaargah-home' }).href"
      >
        {{ $t('BAZAARGAH_TOUCHPOINT.CTA') }}
      </a>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'BazaargahTouchPoint',
};
</script>

<style lang="scss">
.bazaargah-touchpoint {
  width: 100%;
  margin-top: auto;
  padding: 1rem;
  flex-shrink: 0;

  &__card {
    width: 188px;
    margin: 0 auto;
    padding: 1.25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    border-radius: 1rem;
    background-color: rgba(47, 95, 191, 0.05);
  }

  &__image {
    width: 120px;
    height: 83px;
    display: block;
    background-color: transparent;
  }

  &__description {
    width: 100%;
    margin: 0;
    color: #09090b;
    font-size: 0.75rem;
    line-height: 1.25rem;
    letter-spacing: 0.0075rem;
    text-align: center;
  }

  &__link {
    min-height: 2rem;
    padding: 0.375rem 0.75rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    color: #fafafa;
    background-color: #2f5fbf;
    box-shadow: 0 1px 1px rgba(26, 26, 26, 0.05);
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.25rem;
    text-decoration: none;
    transition: background-color 0.2s ease;

    &:hover,
    &:focus {
      color: #fafafa;
      background-color: #284fa0;
    }

    &:focus-visible {
      outline: 2px solid #2f5fbf;
      outline-offset: 2px;
    }
  }
}

.off-canvas--collapsed {
  .bazaargah-touchpoint {
    display: none;
  }
}
</style>
